import { createSvgIcon } from '@mui/material';

export const Edit = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.79183 15.3735C2.82748 15.0526 2.84531 14.8922 2.89386 14.7422C2.93693 14.6092 2.99779 14.4825 3.07478 14.3658C3.16155 14.2342 3.27571 14.12 3.50401 13.8917L13.7529 3.64291C14.6101 2.7857 15.9999 2.7857 16.8571 3.64291C17.7143 4.50012 17.7143 5.88993 16.8571 6.74714L6.60824 16.996C6.37994 17.2243 6.26579 17.3384 6.13419 17.4252C6.01744 17.5022 5.89082 17.563 5.75777 17.6061C5.6078 17.6547 5.44736 17.6725 5.12647 17.7082L2.5 18L2.79183 15.3735Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'Edit',
);
